import type { Request } from '../../../index'
import { CategoryList, Params } from 'app/dataTypes/categories'

export type CategoryItem = {
  id: number,
  title: string,
  index: number // для упорядочивания
}

export type ItemCategoriesResult = {
  [id: string]: CategoryItem
}

type UrlParams = {
  orgId: number | string,
}
export const convertParams = (params: Params): [null, UrlParams] => {
  const { orgId } = params
  return [null, { orgId: orgId }]
}

export const convertResult = (categoriesApi: ItemCategoriesResult): Array<CategoryList> => {
  const categories = Object.entries(categoriesApi).map(([id, { title, index }]) => ({
    id,
    title,
    index,
  }))

  return categories.sort((a, b) => {
    if (a.index === b.index) return a.title.localeCompare(b.title)
    return a.index - b.index
  })
}

export const GET_CATEGORIES_LIST: Request<void,
  Array<CategoryList>,
  UrlParams> = [
    'food/schools/{orgId}/item_categories',
    'get',
    ['data', 'categories'],
  ]
